import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { createAppServices } from "./bootstrap/createApp.ts";
import "./presentation/design-system/global.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element missing.");
}

void createAppServices().then((services) => {
  createRoot(root).render(
    <StrictMode>
      <App services={services} />
    </StrictMode>,
  );
});
